export default "66038c684027ab5a.svg"